import { useQuery } from "@tanstack/react-query"
import { getNavigationQueryOptions } from "../queryOptions/getNavigationQueryOptions"
import { EMPTY_NAVIGATION_CONTENT, type NavigationContent } from "../types/navigationContent"

/**
 * Returns the editable navigation content.
 *
 * Falls back to empty menus while loading, or when Storyblok is unavailable.
 * Consumers treat empty menus as "use the hardcoded ones", so the navigation
 * always renders something.
 */
export function useNavigationContent(): NavigationContent {
    const { data } = useQuery(getNavigationQueryOptions())

    return data ?? EMPTY_NAVIGATION_CONTENT
}
